@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;

$var-main-filter-width: 100px;

$var-search-left-margin: -13px;
$var-main-filter-margin-left: -21px;

.filter-container {
	display: flex;
	flex-direction: row;
	margin-right: auto;
}

.additional-filters {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	padding-top: Constants.$val-spacing-xxs;
	gap: Constants.$val-spacing-s;

	&__add {
		background-color: Colors.$col-white;
		border: 1px solid Colors.$col-design-grey14;
		border-radius: Constants.$val-borderRadius;
		height: Constants.$val-inputHeight;
	}
}

.add-filter-text {
	color: Colors.$col-design-grey15;
}

.bulk-modal {
	&__filter {
		display: grid;
		/* 2 columns, 2fr/3fr split */
		grid-template-columns: 2fr 3fr;
		width: 100%;
		gap: 12px;

		&__search-text {
			border: 1px solid Colors.$col-design-grey14;
			border-radius: 2px;
			width: 104%;
			height: Constants.$val-inputHeight;
			margin-left: $var-search-left-margin;
		}
	}

	&__main-filter {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		margin-bottom: 12px;

		& .bulk-modal__date-filter > div {
			display: flex;
			flex-direction: row-reverse;
			margin: 0;
		}

		&__dropdown {
			border: 1px solid Colors.$col-design-grey14;
			border-radius: 2px;
			margin-left: Constants.$val-spacing-l;
		}
	}

	&__date-filter {
		margin-left: $var-main-filter-margin-left;
	}
}

.job-work-summary {
	&__empty-cell {
		color: Colors.$col-greyFontLight;

		&--right-aligned {
			display: flex;
			justify-content: flex-end;
			width: 100%;
		}
	}

	&__review-status-cell {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;

		&--draft {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-greyFontLight;
			}
		}

		&--in-progress {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-orange;
				font-weight: bold;
			}
		}

		&--outdated {
			[class^="icon-dot_outline"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-orange;
				font-weight: bold;
			}
		}

		&--reviewed {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-darkBlueBorder;
				font-weight: bold;
			}
		}

		&--completed {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-green;
				font-weight: bold;
			}
		}

		&--sub-row-cell {
			color: Colors.$col-greyFontLight;
		}

		& > b {
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}
}

.filter-container {
	display: flex;
	flex-direction: row;
	margin-left: Constants.$val-spacing-s;
	margin-right: auto;
	width: max;
}

.add-filter-text {
	color: Colors.$col-design-grey15;
}

.reset-button {
	color: Colors.$col-design-blue500;

	display: flex;
	justify-content: center;
	align-items: center;

	&:hover {
		cursor: pointer;
	}
}

.bulk-modal {
	&__filter {
		display: flex;
		flex-direction: row;
		width: 100%;

		> :nth-child(1) {
			flex: 2;
		}

		> :nth-child(2) {
			flex: 3;
		}
	}

	&__main-filter {
		display: flex;
		align-items: center;
		width: 100%;
		margin-bottom: 12px;

		> :nth-child(1) {
			flex: 4;
		}

		> :nth-child(2) {
			flex: 1;
		}

		> :nth-child(3) {
			flex: 5;
		}

		&__dropdown {
			border: 1px solid Colors.$col-design-grey14;
			border-radius: 2px;
		}
	}
}

.cell-ellipsed {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
